import { createAction } from 'redux-actions'
import {
  GET_DATA_INTEGRATIONS,
  GET_DATA_INTEGRATIONS_FAILED,
  GET_DATA_INTEGRATIONS_SUCCEEDED,
  SYNC_DATA_INTEGRATION,
  SYNC_DATA_INTEGRATION_FAILED,
  SYNC_DATA_INTEGRATION_SUCCEEDED,
  CONNECT_DATA_INTEGRATION,
  CONNECT_DATA_INTEGRATION_FAILED,
  CONNECT_DATA_INTEGRATION_SUCCEEDED,
  DISCONNECT_DATA_INTEGRATION,
  DISCONNECT_DATA_INTEGRATION_FAILED,
  DISCONNECT_DATA_INTEGRATION_SUCCEEDED,
  GET_QUICKBOOK_CONNECTION,
  GET_QUICKBOOK_CONNECTION_FAILED,
  GET_QUICKBOOK_CONNECTION_SUCCEEDED,
  SYNC_EXPORT_DATA,
  SYNC_EXPORT_DATA_FAILED,
  SYNC_EXPORT_DATA_SUCCEEDED,
  SYNC_EXPORT_NO_RECORDS_SELECTED,
} from 'Redux/Types/DataIntegrationTypes'

export const getDataIntegrations = createAction(GET_DATA_INTEGRATIONS)
export const getDataIntegrationsFailed = createAction(GET_DATA_INTEGRATIONS_FAILED)
export const getDataIntegrationsSucceeded = createAction(GET_DATA_INTEGRATIONS_SUCCEEDED)

export const syncDataIntegration = createAction(SYNC_DATA_INTEGRATION)
export const syncDataIntegrationFailed = createAction(SYNC_DATA_INTEGRATION_FAILED)
export const syncDataIntegrationSucceeded = createAction(SYNC_DATA_INTEGRATION_SUCCEEDED)

export const connectDataIntegration = createAction(CONNECT_DATA_INTEGRATION)
export const connectDataIntegrationFailed = createAction(CONNECT_DATA_INTEGRATION_FAILED)
export const connectDataIntegrationSucceeded = createAction(CONNECT_DATA_INTEGRATION_SUCCEEDED)

export const disconnectDataIntegration = createAction(DISCONNECT_DATA_INTEGRATION)
export const disconnectDataIntegrationFailed = createAction(DISCONNECT_DATA_INTEGRATION_FAILED)
export const disconnectDataIntegrationSucceeded = createAction(
  DISCONNECT_DATA_INTEGRATION_SUCCEEDED,
)

export const getQuickBookConnection = createAction(GET_QUICKBOOK_CONNECTION)
export const getQuickBookConnectionFailed = createAction(GET_QUICKBOOK_CONNECTION_FAILED)
export const getQuickBookConnectionSucceeded = createAction(GET_QUICKBOOK_CONNECTION_SUCCEEDED)

export const syncExportData = createAction(SYNC_EXPORT_DATA)
export const syncExportDataNoRecords = createAction(SYNC_EXPORT_NO_RECORDS_SELECTED)
export const syncExportDataFailed = createAction(SYNC_EXPORT_DATA_FAILED)
export const syncExportDataSucceeded = createAction(SYNC_EXPORT_DATA_SUCCEEDED)
